export default __webpack_public_path__ + "static/favicon-82d27fceb05ea3900a4b6733fcc432cf.ico";